import { SetEquivalentDocFormErrorsAction } from '../../../actions/equivalentDocAction';

export const checkFormErrors = (dispatch, customer, form, adnumeracion) => {
  const errors = [];
  if (customer === null) {
    errors.push('No se ha seleccionado un cliente');
  }

  if (!!form && !!form.numericalID && !!adnumeracion) {
    const numeracion = adnumeracion.find(
      (n) => n.id.toString() === form.numericalID.toString()
    );

    if (!!numeracion) {
      let consecactual = parseInt(numeracion.consecactual, 10);
      let consecfinal = parseInt(numeracion.consecfinal, 10);

      if (isNaN(consecactual) || isNaN(consecfinal)) {
        errors.push('Los valores de consecutivos no son válidos');
      } else if (consecactual > consecfinal) {
        errors.push(
          'La resolución seleccionada ha alcanzado el límite de consecutivos'
        );
      }
    }
  }

  dispatch(SetEquivalentDocFormErrorsAction(errors));
  return errors.length > 0;
};
